export { getCookie, getAnonymousId, extractAnonymousIdFromRequest } from './page_cookies'
